import { Component, ViewChild } from '@angular/core';
import { IonTabs, NavController } from '@ionic/angular';

import { AuthService } from '../services/auth.service';
import { EventService } from '../services/event.service';

@Component({
  selector: 'app-tabs',
  templateUrl: 'tabs.page.html',
  styleUrls: ['tabs.page.scss'],
})
export class TabsPage {
  @ViewChild('tabs') tabs!: IonTabs;
  borrego = false;
  expresotec = false;
  mayExpresotec = false;

  constructor(private navCtrl: NavController, private authService: AuthService, private eventService: EventService) {
    this.eventService.watch.subscribe((value) => {
      if (value === 'campus:change') {
        this.checkUser();
      }
      if (value === 'user:update') {
        this.updateUser();
      }
    });
    this.checkUser();
  }

  updateUser() {
    this.authService.getUserFromServer().then(() => {
      this.checkUser();
    });
  }

  checkUser() {
    this.authService.hasMealplan().then((hasMealplan) => {
      if (hasMealplan) {
        this.borrego = true;
      } else {
        this.borrego = false;
      }
    });

    this.authService.canExpresotec().then((canExpresotec) => {
      if (canExpresotec) {
        this.expresotec = true; // true;
      } else {
        this.expresotec = false;
      }
    });

    this.authService.mayExpresotec().then((mayExpresotec) => {
      if (mayExpresotec) {
        this.mayExpresotec = true; // true;
      } else {
        this.mayExpresotec = false;
      }
    });
  }

  async openTab(tab: string, evt: MouseEvent) {
    const tabSelected = this.tabs.getSelected();
    evt.stopImmediatePropagation();
    evt.preventDefault();
    return tabSelected !== tab
      ? await this.navCtrl.navigateRoot(this.tabs.outlet.tabsPrefix + '/' + tab)
      : this.tabs.select(tab);
  }
}
